import { Skeleton } from './Skeleton';

/**
 * Skeleton for the header component
 */
export function HeaderSkeleton() {
  return (
    <div className="px-4 py-3 flex items-center justify-between">
      <div className="flex-1 space-y-2">
        {/* Restaurant name */}
        <Skeleton className="h-6 rounded w-48" />
        {/* Subtitle/hours */}
        <Skeleton className="h-4 rounded w-32" />
      </div>
      {/* Search button */}
      <Skeleton className="w-10 h-10 rounded-full" />
    </div>
  );
}

